import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useTranslation } from 'react-i18next'
import { Box, CircularProgress, Typography } from '@mui/material'

import { BackToTop, ErrorServer, FooterSticky } from '~/components'

import ContentSearch from './components/ContentSearch'
import HeaderSearch from './components/HeaderSearch'
import { heightFooterSticky } from '~/constants'
import { fetchSearchFoodList, foodItemsSearch } from './searchSlice'
import MyCartBar from '~/components/MyCartBar'
import { isElectronicMenu } from '~/utils'
import { useAppContext } from '~/contexts/AppContext'
import ScrollTop from '~/components/ScrollTop'

export const KEY_SEARCH = 'keyword'
const MIN_LENGTH_ITEM = 5

const SearchDishes = () => {
  const { heightHeaderFixed } = useAppContext()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const keyword = queryParams.get(KEY_SEARCH)

  const { i18n } = useTranslation()
  const dispatch = useDispatch()
  const { listFoodSearch, paging, error } = useSelector(foodItemsSearch)
  const { current_page, total_page, total } = paging
  const fetchMoreListFood = () => {
    if (current_page >= total_page) return
    dispatch(fetchSearchFoodList({ keyword, page: current_page + 1 }))
  }

  useEffect(() => {
    dispatch(fetchSearchFoodList({ keyword }))
  }, [dispatch, i18n.language])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [keyword])

  const renderListFooter = () => {
    if (current_page >= total_page && total > MIN_LENGTH_ITEM) return <BackToTop />
    if (total > 0 && current_page < total_page)
      return (
        <Typography component="div" width="100%" display="inline-flex">
          <CircularProgress sx={{ margin: 'auto' }} size="20px" />
        </Typography>
      )
    return <Box marginTop="40px" />
  }

  const renderCart = () => {
    if (isElectronicMenu()) return null
    return (
      <FooterSticky>
        <MyCartBar />
      </FooterSticky>
    )
  }

  if (error) return <ErrorServer />

  // Hiển thị icon scroll to top
  const renderScrollTopIcon = () => {
    return <ScrollTop />
  }

  return (
    <Box
      maxWidth={'md'}
      marginX={'auto'}
      marginTop={`${heightHeaderFixed}px`}
      minHeight={`calc(100vh - ${heightHeaderFixed}px)`}
      paddingBottom={`${heightFooterSticky}px`}>
      <HeaderSearch keyword={keyword} />
      <Box>
        <InfiniteScroll
          dataLength={listFoodSearch.length}
          next={fetchMoreListFood}
          hasMore={true}
          loader={renderListFooter()}>
          <ContentSearch total={total} listFood={listFoodSearch || []} />
        </InfiniteScroll>
      </Box>
      {renderCart()}
      {renderScrollTopIcon()}
    </Box>
  )
}
export default React.memo(SearchDishes)
